export const unknownPropertiesHelper = (
  unknownProperties: string | undefined,
  scanResult: string
) => {
  const isSRT = scanResult?.startsWith('VA');
  const isBatteryPack = scanResult?.startsWith('MB');

  const unknownPropertiesArray =
    unknownProperties?.split(';').filter(Boolean) || [];
  let newUnknownProperties = '';

  if (isSRT) {
    const updatedArray = unknownPropertiesArray.filter(
      (prop) => !prop.startsWith('VA')
    );
    updatedArray.unshift(scanResult);
    newUnknownProperties = updatedArray.join(';');
  } else if (isBatteryPack) {
    const updatedArray = unknownPropertiesArray.filter(
      (prop) => !prop.startsWith('MB')
    );
    updatedArray.push(scanResult);
    newUnknownProperties = updatedArray.join(';');
  } else {
    newUnknownProperties = scanResult;
  }
  console.debug('newUnknownProperties: ' + newUnknownProperties);
  return newUnknownProperties;
};
